"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resourceLinkRegex = '^https?://[a-z0-9./:-]+/([a-z0-9]{24})$';
exports.default = resourceLinkRegex;
//# sourceMappingURL=ResourceLinkRegex.js.map